import { React, useState, useEffect, useRef } from "react";
import * as ReactDOM from "react-dom";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import {
  Menu,
  MenuItem,
  MenuItemLink,
  MenuSelectEvent,
} from "@progress/kendo-react-layout";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import moment from "moment";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import { uniq, map, flatten } from "lodash";
import { DropDownList, ComboBox } from "@progress/kendo-react-dropdowns";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../Core/store.hooks";

import { useNavigate } from "react-router-dom";

const initialSort: any[] = [
  {
    field: "customerName",
    dir: "asc",
  },
];

interface ServiceCallGridProps {
  data?: any | null;
}

const ServiceCallGrid = (props: ServiceCallGridProps) => {
  const [data, setData] = useState(props.data);
  const [sort, setSort] = useState(initialSort);
  const [isPagable, updateIsPagable] = useState(false);
  const [page, setPage] = useState({
    skip: 0,
    take: 10,
  });
  const pageChange = (event) => {
    setPage(event.page);
  };

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  const dateCell = (cellProps: any) => {
    if (cellProps.dataItem.latestTime == null) return <td></td>;
    return (
      <td>
        {moment(cellProps.dataItem.latestTime).format("DD.MM.YYYY HH:MM:ss")}
      </td>
    );
  };
  const _export = useRef<ExcelExport | null>(null);
  const excelExport = (event: MenuSelectEvent) => {
    if (event.item.text === "Export to Excel") {
      if (_export.current !== null) {
        _export.current.save();
      }
    }
  };
  const linkRender = (props: any) => {
    return (
      <MenuItemLink url={props.item.url} opened={props.opened}>
        {[renderMenuIconIfApplicable(props), props.item.text, null]}
      </MenuItemLink>
    );
  };
  function renderMenuIconIfApplicable(props: any) {
    return props.item.icon ? (
      <span
        style={{ fontSize: "16px" }}
        className={`k-icon k-i-${props.item.icon}`}
        role="presentation"
        key="0"
      />
    ) : null;
  }
  return (
    <div style={{ height: "100%", position: "relative" }}>
      <div
        style={{
          position: "absolute",
          top: "-20px",
          left: "-20px",
        }}
      >
        <Menu openOnClick={true} onSelect={excelExport} linkRender={linkRender}>
          <MenuItem
            text=""
            icon="more-horizontal"
            data={{}}
            cssStyle={{ color: "black" }}
          >
            <MenuItem text="Export to Excel" />
          </MenuItem>
        </Menu>
      </div>
      <ExcelExport data={data} ref={_export}>
        <Grid
          pageable={isPagable}
          data={orderBy(data, sort)}
          //   skip={page.skip}
          //   take={page.take}
          //   onPageChange={pageChange}

          resizable={true}
          total={data.length}
          sortable={true}
          sort={sort}
          onSortChange={(e: any) => {
            setSort(e.sort);
          }}
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          <Column field="deviceName" title="Device Name" />
          <Column field="deviceSize" title="Device Size" />
          <Column field="versionNumber" title="Version Number" />
          <Column field="serialNumber" title="Serial" />
          <Column field="projectNumber" title="Project Number" />
          <Column field="ip" title="IP Address" />

          <Column field="macAddress" title="MAC Address" />
          <Column field="moreInfo" title="More Info" />

          <Column field="latestTime" title="Data Updated" cell={dateCell} />
        </Grid>
      </ExcelExport>
    </div>
  );
};
export default ServiceCallGrid;
